import React from 'react'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { BaseCard, CardField } from 'components'

export const CardCadaver = (props) => {
  moment.locale('pt-br', localization)
  const { cadaver, handleClick } = props

  return (
    cadaver ? (
      <BaseCard
        avatar="CADAVER"
        title="Cadáver"
        onClick={() => handleClick(cadaver.id)}
        onNovaAba={() => handleClick(cadaver.id, true)}
      >
        <CardField label="NIC" value={cadaver.nic || 'NÃO INFORMADO'} />
        <CardField label="Status" value={cadaver.status} />
        <CardField label="Data de entrada" value={moment(cadaver.createdAt).format('DD/MM/YYYY')} />
        <CardField
          label="Descrição"
          value={
            cadaver.descricaoGeral && cadaver.descricaoGeral.length > 80
              ? `${cadaver.descricaoGeral.slice(0, 80)}...`
              : cadaver.descricaoGeral || 'sem descrição'
          }
        />
      </BaseCard>
    ) : null
  )
}
